import React from 'react';
import { useTranslation } from 'react-i18next';

const PropertyItemVitaminTypeError = () => {
    const { i18n } = useTranslation();
    return (
        <p className="error">{i18n.t('app.page.property.vitaminError')}</p>
    );
};

export default PropertyItemVitaminTypeError;
